__turbopack_context__.v({
  "hero": "ugbv9q_hero",
  "image": "ugbv9q_image",
  "title": "ugbv9q_title",
});
